"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const redux_1 = require("redux");
const actions_1 = require("~/store/actions");
const useActionToken_1 = __importDefault(require("~/hooks/useActionToken"));
const NewPassword_1 = __importDefault(require("./NewPassword/NewPassword"));
const RestorationLoader_1 = __importDefault(require("./RestorationLoader/RestorationLoader"));
const RestorePasswordDefault_1 = __importDefault(require("./RestorePasswordDefault/RestorePasswordDefault"));
function RestorationModal({ restorationMode }) {
    var _a;
    const [mode, setMode] = (0, react_1.useState)(restorationMode !== null && restorationMode !== void 0 ? restorationMode : 'restore');
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const [token, isTokenValid] = (0, useActionToken_1.default)((_a = searchParams.get('token')) !== null && _a !== void 0 ? _a : '');
    const { dispatchSendRestorePasswordLink, dispatchChangePasswordAction } = (0, redux_1.bindActionCreators)({
        dispatchSendRestorePasswordLink: actions_1.sendRestorePasswordLink,
        dispatchChangePasswordAction: actions_1.changePasswordAction,
    }, (0, react_redux_1.useDispatch)());
    const switchToNewPassword = () => setMode('newPassword');
    const sendPasswordLink = (email) => {
        dispatchSendRestorePasswordLink(email === null || email === void 0 ? void 0 : email.toLowerCase());
    };
    const sendNewPassword = (password) => {
        if (isTokenValid && token) {
            dispatchChangePasswordAction({ token, password });
        }
    };
    (0, react_1.useEffect)(() => {
        if (isTokenValid) {
            switchToNewPassword();
        }
    }, [token, isTokenValid]);
    if (isTokenValid === null) {
        return react_1.default.createElement(RestorationLoader_1.default, null);
    }
    return mode === 'restore' ? (react_1.default.createElement(RestorePasswordDefault_1.default, { onSubmit: sendPasswordLink })) : (react_1.default.createElement(NewPassword_1.default, { onSubmit: sendNewPassword }));
}
exports.default = RestorationModal;
